import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=7c5dd63d"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=7c5dd63d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports